<script setup lang="ts">
import type { DropdownMenuItem } from '@nuxt/ui';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAppConfig } from '#app/config';
import { OverflowMenu } from '#layers/ui';

const props = defineProps<{
	canTurnIntoGroup?: boolean;
	disabled?: boolean;
}>();

const emit = defineEmits<{
	remove: [];
	duplicate: [];
	turnIntoGroup: [];
}>();

const appConfig = useAppConfig();
const { t } = useI18n();

const items = computed<DropdownMenuItem[]>(() => [
	{
		label: t('common.remove'),
		class: 'data-highlighted:text-error [&>span]:group-data-highlighted:text-error',
		icon: appConfig.ui.icons.trash,
		onSelect: () => emit('remove'),
	},
	{
		label: t('common.duplicate'),
		icon: 'lucide:copy',
		onSelect: () => emit('duplicate'),
	},
	props.canTurnIntoGroup && {
		label: t('filters.turn_into_group'),
		icon: 'lucide:arrow-right-left',
		onSelect: () => emit('turnIntoGroup'),
	},
].filter(Boolean) as DropdownMenuItem[]);
</script>

<template>
	<OverflowMenu
		:items
		:disabled
		:trigger="{
			size: 'sm',
		}"
	/>
</template>
